<div class="modal-content">
  <div class="div-message-box animated fadeIn fast">
    <div class="message-box-container animated fadeIn fast">
      <div class="message-box-middle">
        <span class="msg-title">
          <i class="fa fa-sign-out txt-color-orangeDark"></i>Confirm Delete
        </span>
        <p class="p-text">Are you sure you want to delete?</p>
        <div class="message-box-button-section">
          <button class="btn btn-default btn-xs" (click)="cancel()">No</button>
          <button class="btn btn-danger btn-xs" (click)="confirmDelete()" [disabled]="processing">
            @if (processing) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
